import React, { Component } from 'react';

export default class DetectRadioItem extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  render() {
    const {
      text,
      ...rest
    } = this.props;
    return (
      <div className={['detect-radio-item', this.props.checked ? 'checked' : ''].join(' ')}>
        <input type="radio" {...rest} onChange={this.onChange} />
        <div className="override-container">
          <div className="circle"></div>
          <div className="text">{text}</div>
        </div>
      </div>
    );
  }
}
